export enum LegacyVoucherTypes {
  CODE = "CODE",
  LIST = "LIST"
}

export enum VoucherTypes {
  CODE = "code",
  LIST = "list"
}
